import Vue from "vue";
import App from "./App.vue";
import {
  Button,
  Image,
  Tooltip,
  DropdownItem,
  Dropdown,
  DropdownMenu,
  Message,
  Switch,
  Popover,
  Slider,
  Loading,
  Select,
  Option,
  Dialog,
  Form,
  FormItem,
  Input
} from "element-ui";
const dayjs = require('dayjs')

Vue.use(Button);
Vue.use(Image);
Vue.use(Tooltip);
Vue.use(DropdownItem);
Vue.use(Dropdown);
Vue.use(DropdownMenu);
Vue.use(Switch);
Vue.use(Popover);
Vue.use(Slider);
Vue.use(Select);
Vue.use(Dialog);
Vue.use(Form);
Vue.use(FormItem);
Vue.use(Input);
Vue.use(Option)

Vue.prototype.$dayjs = dayjs
Vue.config.productionTip = false;
Vue.prototype.$message = Message;
Vue.prototype.$loading = Loading.service;
new Vue({
  render: (h) => h(App),
  beforeCreate() {
    Vue.prototype.$bus = this
  },
  $dayjs: dayjs
}).$mount("#app");
